const KnockbackEvent = require( './KnockbackEvent' );
const { logError } = require('../logger')

const BattleEventFactory = {			
	makeKnockbackEvent: function( battleState, forceTile, victim, potency )	{
    try {
  		var dest_x, dest_y;
  		var destinationTile;
  		
  		for( potency; potency >= 0.5; potency-=0.5 ) {
  			dest_x = victim.x + potency*( victim.x - forceTile.x );
  			dest_y = victim.y + potency*( victim.y - forceTile.y );
  			destinationTile = battleState.getTileAtCoords( dest_x, dest_y );
  			
  			if( !destinationTile ) {
  				continue;
  			}
  			
  			if( !destinationTile.occupied ) {
  				break;
  			}
  		}
  		
  		if( !destinationTile || destinationTile.occupied ) {
  			destinationTile = battleState.getTileAtCoords( victim.x, victim.y );	
  		}
  		
  		var knockback = new KnockbackEvent( battleState, victim );
  		knockback.execute( forceTile, destinationTile );
  		return knockback;
    } catch (err) {
      logError(err, {
        module: 'BattleEventFactory',
        func: 'makeKnockbackEvent',
        battleState,
        forceTile,
        victim,
        potency
      })
    }
	}
}
module.exports = BattleEventFactory
